import React from 'react'
import { TableBodyFont, TableHorizontalAlignment, TableVerticalAlignment } from '@lib/types/component-table'
import { pxToRem } from '@lib/utils/css'
import { horizontalAlignMap, verticalAlignMap } from './utils'
import styles from './table-cell.module.scss'

export interface TableCellProps {
  children: React.ReactNode
  config?: TableCellConfig
}

export interface TableCellConfig {
  font: TableBodyFont
  verticalAlignment: TableVerticalAlignment
  horizontalAlignment: TableHorizontalAlignment
}

const fontSizeMap: Record<TableBodyFont, { fontSize: string; lineHeight: string }> = {
  [TableBodyFont.NormalTextLarge]: { fontSize: pxToRem(18), lineHeight: pxToRem(27) },
  [TableBodyFont.NormalTextMedium]: { fontSize: pxToRem(16), lineHeight: pxToRem(24) },
  [TableBodyFont.NormalTextSmall]: { fontSize: pxToRem(14), lineHeight: pxToRem(21) },
}

export const TableCell: React.FC<TableCellProps> = ({ children, config }) => {
  const {
    font = TableBodyFont.NormalTextMedium,
    verticalAlignment = TableVerticalAlignment.Top,
    horizontalAlignment = TableHorizontalAlignment.Left,
  } = config ?? {}
  return (
    <td
      className={styles.cell}
      style={{
        verticalAlign: verticalAlignMap[verticalAlignment],
        textAlign: horizontalAlignMap[horizontalAlignment],
        fontSize: fontSizeMap[font].fontSize,
        lineHeight: fontSizeMap[font].lineHeight,
      }}
    >
      {children}
    </td>
  )
}
